import React from 'react';
import DashboardShell from '../../../layouts/DashboardShell';
import ClientJobList from '../../../features/jobs/components/ClientJobList';
import useActiveJobs from '../../../features/jobs/hooks/useActiveJobs';
import { clientSideLinks } from '../clientRoutes';
import CardIcon from '../../../shared/components/icons/CardIcon';

function ClientJobsPage() {
  const { jobs, loading, error, reload } = useActiveJobs();
  return (
    <DashboardShell role="CLIENT" sideLinks={clientSideLinks}>
      <div className="space-y-6">
        <div className="rounded-3xl bg-white p-6 shadow-sm">
          <h1 className="flex items-center gap-3 text-2xl font-bold text-navy"><CardIcon name="briefcase" className="h-6 w-6" />Active Jobs</h1>
          <p className="mt-2 text-sm text-slate-600">Review your posted jobs and track worker progress.</p>
        </div>

        <ClientJobList
          jobs={jobs}
          loading={loading}
          error={error}
          emptyMessage="No active jobs found."
          onJobChanged={reload}
        />
      </div>
    </DashboardShell>
  );
}

export default ClientJobsPage;
